import React from 'react';
import { withTranslation } from 'react-i18next';
import { Card, Icon, Button, Header, Checkbox } from 'semantic-ui-react';

import {getCompetitionImageUrl } from './tools.js';
import Utils from 'utils/Utils.js';
import LoadInline from '../loading/LoadInline.js';
import {colors, spacings} from 'style';
import { fontSizes } from '../../style/index.js';

import DeletePromptContainer from 'modules/misc/DeletePromptContainer.js';

var style = {
    content: {
        padding: '1px',
        position:'relative'
    },
    loaderContainer: {
        marginLeft:'50%'
    },
    subtitle: {
        textAlign: 'center',
    },
    card: {
        overflow:'hidden',
        backgroundColor: colors.themeWhite,

        width:'24rem',
    },
    header: {
        
        color:colors.themeDarkerGrey, 
    },
    iconHeader: {
        padding:spacings.small, 
        width:'100%',
        color: colors.themeBlue,
        fontSize: fontSizes.bodyL,
        //backgroundColor: colors.themeTeal,
    },
    imageBanner: {
        position: 'relative',
        height:'13.5rem', 
        width:'24rem',
        backgroundSize:'cover',
        backgroundPositionY: 'center',
    },
    checkmark: {
        color : colors.themeTeal
    },
    toggle: {
        position: 'relative',
        top: '3px',
    },
    editButton: {
        //position: 'absolute',
        //top: '10px',
        //right: '10px',
        float : 'right',
        backgroundColor: colors.themeWhite,
        border: 'none',
        boxShadow: 'none',
        fontSize: '1.5rem',
        padding: '0px',
        margin: '0',
    },
    editIcon: {
        margin: '0',
        opacity: '1',
        color: colors.themeDarkGrey,
    },
    date : {
    	float :'right',
    	marginRight:'1rem',
    	color: colors.themeDarkerGrey,
    }
};

const ChallengeCard = ({
	t, 
    competition,
    onEdit,
    onClick,
    onClickChange,
    centered,
    onExport,
    onDelete
}) => {

    const deleteCompetitionRef = React.createRef();

    return <>
        <Card key={competition.id} className='nohover'style={style.card} centered={centered}>
            <Card.Header onClick={onClick}>
                <div style={style.iconHeader}>
                {competition.title}
            </div>
            <div style={{ ...style.imageBanner, backgroundImage: Utils.url(getCompetitionImageUrl({ competition })) }}></div>
            </Card.Header>
     
            
            { localStorage.master == 'true' && <div style={{ "padding": "0.5em", "textAlign": "right" }}><span style={{float:'left'}}>ID: {competition.id}</span><a onClick={() => deleteCompetitionRef.current.showDeletePrompt(competition)}><Icon name='trash' /></a></div> }
        </Card>
        <DeletePromptContainer ref={deleteCompetitionRef} onDeleteConfirmation={onDelete} message='Are you sure you want to remove this challenge template?' />
    </>
};


export default withTranslation('competitions')(ChallengeCard);
